module.exports = "\n    <div md-dialog-content >{{Message}}..</div>\n    <div md-dialog-actions>\n        <md-progress-bar mode=\"indeterminate\"></md-progress-bar>\n    </div>"


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/trade-back/loading-dialog.html
// module id = ../../../../../src/app/pages/trade-back/loading-dialog.html
// module chunks = 39